import loadYmaps from '../../helpers/ymaps-loader';
import OdpPageView from '../../components/Branch/OdpPageView';
import MapWidgetFind from '../../components/MapWidgetFind/MapWidgetFind.vue';
import { listenToStartSearchTrackEvent as initTrackWidgetModal } from '../../components/TrackingWidget/TrackWidgetModal.vue';
import { factory as initMobileHeaderMenu } from '../../components/MobileHeaderMenu/MobileHeaderMenu.vue';
import { factory as personalAccountButtonFactory } from '../../components/PersonalAccountChoiceModal/PersonalAccountButton.vue';
import initApplicationGlobal from '../Global/Global';

import VueFactory from '../../helpers/vueFactory';
import mobileMountingComponent from "@/helpers/component-installer";

export default function initApplicationTracking(eventHub, odp) {
  const options = {
    mobileStoreLinks: {
      googlePlayLink: 'https://redirect.appmetrica.yandex.com/serve/315210307565828105?click_id={find_an_office}',
      appStoreLink: 'https://redirect.appmetrica.yandex.com/serve/171095121050267353?click_id={find_an_office}',
      qrCodeImageSrc: 'https://storage.yandexcloud.net/boxberrysite-public/img/qr-code.svg',
    },
  };

  initApplicationGlobal(eventHub, options);

  if (odp) {
    if (document.getElementById('odpPageView')) {
      loadYmaps().then(() => {
        VueFactory(OdpPageView, {
          el: '#odpPageView',
          data: {
            eventHub,
          },
        });
      });
    }
  } else {
    loadYmaps().then(() => {
      VueFactory(MapWidgetFind, {
        el: '#mapWidgetFind',
        data: {
          eventHub,
        },
      });
    });
  }

  if (document.getElementById('tracking-gift')) {
    const GiftFindCard = () => import(
      /* webpackChunkName: "GiftFindCard" */
      '../../components/GiftCard/GiftFindCard.vue'
      );
    GiftFindCard().then((module) => {
      mobileMountingComponent('#tracking-gift')
        .then(() => {
          VueFactory(module.default, {
            el: '#tracking-gift',
          });
        });
    });
  }

  initTrackWidgetModal();

  initMobileHeaderMenu({
    subpage: true,
  });

  personalAccountButtonFactory({
    classModifier: 'button-accounts_header-desktop',
    restorePopupMode: 'desktop',
  });
}
